import { Response } from '@marketplace-web/shared/api-client'
import { transformCurrencyAmountDto } from '@marketplace-web/domain/currency-data'

import {
  ClosetPromotionPricingDto,
  ClosetPromotionPricingModel,
  ClosetPromotionPricingResp,
} from '../types/closet-promotion-pricing'

export const transformClosetPromotionPricing = (
  dto: ClosetPromotionPricingDto,
): ClosetPromotionPricingModel => ({
  effectiveDays: dto.effective_days,
  isSalesTaxApplicable: dto.sales_tax_applicable,
  totalPrice: transformCurrencyAmountDto(dto.total_price),
  pricePerDay: transformCurrencyAmountDto(dto.price_per_day),
  discountedPrice: transformCurrencyAmountDto(dto.discounted_price),
})

export const transformClosetPromotionPricingResponse = (
  response: Response<ClosetPromotionPricingResp>,
): ClosetPromotionPricingModel => transformClosetPromotionPricing(response.promoted_closet_pricing)
